
import PledgeTier from "./PledgeTier";

interface PledgeTierData {
  id: string;
  name: string;
  amount: number;
  regularPrice: number;
  description: string;
  features: string[];
  discount: string;
  savings: number;
}

interface PledgeTierListProps {
  tiers: PledgeTierData[];
  selectedTier: string | null;
  loading: boolean;
  onPledgeClick: (tierId: string) => void;
}

const PledgeTierList = ({ tiers, selectedTier, loading, onPledgeClick }: PledgeTierListProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {tiers.map((tier) => {
        const isProcessing = selectedTier === tier.id && loading;
        
        return (
          <PledgeTier
            key={tier.id}
            tier={tier}
            isProcessing={isProcessing}
            loading={loading}
            onPledgeClick={onPledgeClick}
          />
        );
      })}
    </div>
  );
};

export default PledgeTierList;
